import App from '@/layouts/website/MainLayout.vue'
import router from '@/routers/website'
import { setupEntryPoint } from './setupEntryPoint'
import '@/assets/css/themes.css'
import '@/assets/css/style.css'

setupEntryPoint(App, router)
